import type { HelpArticle } from '../../../components/help/types';

export const userManagementArticles: HelpArticle[] = [
  {
    id: 'platform-users-overview',
    title: 'Platform User Management',
    summary: 'Managing users across the platform.',
    category: 'user-management',
    order: 1,
    keywords: ['users', 'accounts', 'platform', 'admin', 'management'],
    content: `
# Platform User Management

Manage platform administrators and oversee MDA user activity.

## User Types

### Platform Administrators
- Access to all platform functions
- Manage MDAs and settings
- View cross-MDA analytics
- Handle escalations

### MDA Administrators
- Manage their institution
- Create users within MDA
- Configure MDA settings
- Cannot access other MDAs

### MDA Users
- Regular staff accounts
- Access based on roles
- Work within their MDA only

## Platform Admin Tasks

- Create other platform admins
- Monitor user activity
- Handle account issues
- Reset credentials
- Audit access logs

## Security Considerations

- Limit platform admin accounts
- Use strong passwords
- Enable two-factor authentication
- Review access regularly
- Audit sensitive actions
    `,
  },
];
